module.exports = __webpack_public_path__ + "static/media/logo-red.ee5b4a96.svg";